import { defer } from "lodash";
import { enqueueSnackbar } from "notistack";

import DeleteConfirmation from "fond/project/comments/DeleteConfirmation";
import { deleteAttachments as deleteAttachmentsAction } from "fond/redux/attachments";
import { Attachment } from "fond/types";
import { useAppDispatch } from "fond/utils/hooks";
import { ModalCloseHandler } from "fond/widgets/Modal";

type DeleteAttachmentModalProps = {
  attachments: Attachment[];
  onClose: ModalCloseHandler;
};
export const DeleteAttachmentModal: React.FC<DeleteAttachmentModalProps> = ({ attachments, onClose }: DeleteAttachmentModalProps) => {
  const dispatch = useAppDispatch();

  const handleDelete = async (event: React.MouseEvent<EventTarget>) => {
    try {
      await dispatch(deleteAttachmentsAction(attachments));
      defer(() => onClose(event, "complete"));
      enqueueSnackbar(`Deleted ${attachments.length} ${attachments.length > 1 ? "attachments" : "attachment"}.`);
    } catch (error) {
      enqueueSnackbar("Some attachments failed to delete.");
    }
  };

  return (
    <DeleteConfirmation
      data-testid="attachments-delete-confirmation-modal"
      onClose={onClose}
      onDelete={handleDelete}
      title="Delete attachments"
      message={`Are you sure you wish to delete ${attachments.length > 1 ? `these ${attachments.length} attachments` : "this attachment"}?`}
    />
  );
};
